// ARC-8 toast system: max 3 stacked, auto-dismiss 6 s, error variant persists.
import { useEffect, useState } from "preact/hooks";

export interface Toast {
  id: number;
  kind: "info" | "success" | "error";
  text: string;
  sticky?: boolean;
}

class ToastBus {
  list: Toast[] = [];
  private listeners = new Set<() => void>();
  private nextId = 1;

  subscribe(fn: () => void): () => void {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }

  private notify(): void {
    for (const fn of this.listeners) fn();
  }

  push(kind: Toast["kind"], text: string, sticky = kind === "error"): void {
    const toast: Toast = { id: this.nextId++, kind, text, sticky };
    this.list = [...this.list, toast].slice(-3);
    this.notify();
    if (!toast.sticky) {
      setTimeout(() => this.dismiss(toast.id), 6000);
    }
  }

  dismiss(id: number): void {
    const before = this.list.length;
    this.list = this.list.filter((t) => t.id !== id);
    if (this.list.length !== before) this.notify();
  }
}

export const toasts = new ToastBus();

export function Toasts() {
  const [, bump] = useState(0);
  useEffect(() => toasts.subscribe(() => bump((n) => n + 1)), []);
  return (
    <div class="toasts" role="status" aria-live="polite">
      {toasts.list.map((t) => (
        <div key={t.id} class={`toast ${t.kind}`}>
          <span>{t.text}</span>
          <button class="toast-x" onClick={() => toasts.dismiss(t.id)} aria-label="Dismiss">
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
